export default "__VITE_ASSET__YKLSb_ZZ__"